export enum BulkUploadFilesFlagEnum {
  ON = '1',
  OFF = '0',
}
